export default __webpack_public_path__ + "static/media/grandcanyonKlein.2d2daebb.jpg";